package kz.dentalcrm.app.core.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import io.ktor.http.encodeURLParameter
import kotlinx.browser.window

class JsIntentOperations : IntentOperations {
    /**
     * Opens the phone dialer with the given phone number.
     * Uses the "tel:" URI scheme.
     * @param phoneNumber The phone number to dial.
     */
    override fun openPhoneDialer(phoneNumber: String) {
        window.open("tel:$phoneNumber", "_blank")
    }

    /**
     * Opens WhatsApp chat with the given phone number.
     * Uses the "https://wa.me/" URL scheme.
     * The phone number is sanitized to contain only digits.
     * @param phoneNumber The phone number for the WhatsApp chat.
     */
    override fun openWhatsApp(phoneNumber: String, appendedText: String) {
        // Sanitize the phone number to remove non-digit characters.
        val sanitizedPhoneNumber = phoneNumber.replace("[^0-9]".toRegex(), "")
        window.open("https://wa.me/$sanitizedPhoneNumber${
            if (appendedText.isNotEmpty()) {
                ("?text=${appendedText.encodeURLParameter()}")
            } else ""
        }", "_blank")
    }
}

/**
 * Actual implementation of rememberIntentOperations for the Kotlin/JS (IR) target.
 * Provides a memoized instance of JsIntentOperations.
 * @return An instance of IntentOperations specific to the JS platform.
 */
@Composable
actual fun rememberIntentOperations(): IntentOperations {
    return remember {
        JsIntentOperations()
    }
}

@Composable
actual fun openUrl(urlString: String): Boolean {
    try {
        // Use window.open to open the URL. "_blank" target opens in a new tab/window.
        window.open(urlString, target = "_blank")
        return true
    } catch (e: Exception) {
        // Catch any exceptions that might occur during the window.open call.
        // This might happen if the browser blocks pop-ups or there's an invalid URL.
        console.error("Failed to open URL: $urlString", e) // Log the error for debugging.
        return false
    }
}